import { render, staticRenderFns } from "./inputField.vue?vue&type=template&id=baca90d2"
import script from "./inputField.vue?vue&type=script&lang=js"
export * from "./inputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports